import {
    useCallback,
} from 'react'
import {
    useJWTToken,
} from 'app/Auth'

import {
    FilteredBaseColumn,
} from 'app/types/richtable.types'
import Filter from 'app/shared-components/Filter'
import DateRangeSelectorFilter from 'app/shared-components/DateRangeSelectorFilter'
import useGetUntypedEnumLabel from 'app/hooks/useEnumValues/useGetUntypedEnumLabel'
import IntegerRangeFilter from 'app/shared-components/IntegerRangeFilter'
import {
    FilterType,
} from 'app/enums/common.enums'
import useArchivedTableControl from 'app/shared-components/TableControls/ShowArchived/useArchivedTableControl'
import SwitchFilter from 'app/shared-components/SwitchFilter'

import loadFilters, {
    LoadFiltersParams,
} from './loadFilters'

const filterComponentMap = {
    [FilterType.Array]: Filter,
    [FilterType.DateRange]: DateRangeSelectorFilter,
    [FilterType.IntegerRange]: IntegerRangeFilter,
    [FilterType.BooleanSwitch]: SwitchFilter,
}

const useLoadFilters = ({
    customUrl,
    preDefinedFilters,
    load = loadFilters,
    name,
}:{
    customUrl: string,
    load?: (params: LoadFiltersParams)=> Promise<any>,
    preDefinedFilters?: object,
    name?: string,
}) => {
    const getLabels = useGetUntypedEnumLabel()
    const token = useJWTToken()
    const showArchived = useArchivedTableControl(name)

    return useCallback(
        (columns: FilteredBaseColumn[]) => {
            return columns.map((column: FilteredBaseColumn) => {
                const {
                    filterField,
                    filterType,
                    filterOptions,
                    FilterComponent,
                    rangeType = '',
                    customFilterItemLabelConverter,
                } = column

                const loadFiltersFn = filterField ? (params) => {
                    const newParams = {
                        params: {
                            token,
                            columnInfo: column,
                            props: {
                                ...params,
                                type: rangeType,
                                filters: preDefinedFilters,
                                archived: name ? showArchived : undefined,
                            },
                        },
                        customUrl,
                        getLabels: customFilterItemLabelConverter || getLabels,
                    }

                    return load(newParams)
                } : undefined

                return {
                    ...column,
                    headerProps: {
                        ...column.headerProps,
                        FilterComponent: FilterComponent || filterComponentMap[filterType],
                        filterField,
                        filterOptions,
                        loadFilters: loadFiltersFn,
                    },
                }
            })
        },
        [
            token,
            preDefinedFilters,
            name,
            showArchived,
            customUrl,
            getLabels,
            load,
        ],
    )
}

export default useLoadFilters
